// extracted by mini-css-extract-plugin
export default {"wrapper":"Message_wrapper__Jo3in","blockMsg":"Message_blockMsg__jbmP6","avatar":"Message_avatar__eopdv","avatarBg":"Message_avatarBg__nb4ue","nameAuthor":"Message_nameAuthor__j4q5W"};